module.exports = __webpack_public_path__ + "../resources/img/line_checkbox_selected_lt.bf604250.svg";